import Vue from "vue";

class KioskNavigation {

  private static singleton: KioskNavigation | null = null;
  public static instance(): KioskNavigation {
    if ( null === KioskNavigation.singleton ) {
      KioskNavigation.singleton = new KioskNavigation();
    }
    return KioskNavigation.singleton;
  }

  private navigationStack: string[] = ['/'];
  private constructor() {}

  public to(vm: Vue, routePath: string) {
    this.navigationStack.push(routePath);
    vm.$router.replace(routePath);
  }

  public back(vm: Vue) {
    this.navigationStack.pop();
    if ( this.navigationStack.length > 0 ) {
      vm.$router.replace(this.navigationStack[this.navigationStack.length - 1]);
    }
    else {
      vm.$router.replace('/');
    }
  }

  public home(vm: Vue) {
    this.navigationStack = [];
    vm.$router.replace('/');
  }

}

export const $nav = KioskNavigation.instance();
